/**
 * 处理socket事件
 * 1，公用事件，在此页面进行修改
 * 2，页面事件，提交vuex状态，由页面监听单独处理
 */
import DbConfig from '../../config/DbConfig.js'
import {getLoginId} from '../functions/Common.js'
import {getCustomList,getCustomByWxid,updateCustomOnline} from '../network/local/custom.js'
import {getChatRecordById,updateChatRecordById,deleteChatRecordById} from '../network/local/chat-record.js'
import {webDeleteChatRecord} from '../network/web/chat-record.js'
import {getClusterRecordById,updateClusterRecordById,deleteClusterRecordById} from '../network/local/cluster-chat-record.js'
import {webSaveClusterRecord,webDeleteClusterRecord} from '../network/web/cluster-chat-record.js'
import {saveCluster,saveClusterMember,saveClusterMembers,deleteCluster,deleteClusterMemberByClusterId} from '../network/local/cluster.js'
import {webGetSyncCluster,webGetClusterMember} from '../network/web/cluster.js'
import {handleMsg,changeRTStatus} from '../util/msgUtil.js'
import {saveFriend,updateFriend,getFansByCustomIdAndWxid,deleteFriendById} from '../network/local/friend.js'
import {deleteRecentlyByFIdAndType,updateRecentlyByFIdAndType} from '../network/local/recently.js'
import {deleteFansTagsByFansId,insertFansTags} from '../network/local/custom-friends-tags.js'

// 浏览器socket绑定
export function init(bean,vthis,socket){
	getCustomList((data)=>{
		let toId = []
		for (let i = 0; i < data.length; i++) {
			toId.push(data[i].phone_id)
		}
		socket.send(JSON.stringify({
		  type:'event',
		  status:true,
		  bean:{
		    type:'bindBrow',
		    fromId: getLoginId(),
		    toId: toId.join(',')
		  }
		}))
	})
}

// 浏览器socket绑定回调
export function login(bean,vthis,socket){
	// 更新本地客服在线状态
	if(bean.online !== undefined){
		for(let i in bean.online){
			updateCustomOnline(i,bean.online[i],res=>{
				// console.log(res)
			})
		}
	}
	vthis.$store.commit('updateCustomOnline',{
		obj:bean.online
	})
}

// 发送消息后结果回调
export function MsgRespSecond(bean,vthis,socket){
	if(bean.msgType == 1){
		getChatRecordById(bean.recodeId,(data)=>{
			if(data.id !== undefined){
				let is_send = 1
				let is_update = 1
				if(bean.nRet != 0){
					is_send = 0
					is_update = 2
				}
				let updataData = {
					is_send: is_send,
					msgId: bean.msgId !== undefined ? bean.msgId : 0
				}
				updateChatRecordById(data.id,updataData,(c_data)=>{
					if(c_data){
						// 更新vuex状态值
						let msg = {
							id: bean.recodeId,
							fans_id: data.friend_id,
							is_update: is_update
						}
						vthis.$store.commit('updateCurrentChatMsg',msg)
					}
				})
			}
		})
	}else if(bean.msgType == 2){
		getClusterRecordById(bean.recodeId,(data)=>{
			if(data.id !== undefined){
				let is_send = 1
				let is_update = 1
				if(bean.nRet != 0){
					is_send = 0
					is_update = 2
				}
				let updataData = {
					is_send: is_send
				}
				updateClusterRecordById(data.id,updataData,(c_data)=>{
					if(c_data){
						// 更新vuex状态值
						let msg = {
							id: bean.recodeId,
							fans_id: data.cluster_id,
							is_update: is_update
						}
						vthis.$store.commit('updateCurrentChatMsg',msg)
					}
				})
			}
		})
	}
}

// 浏览器socket绑定回调
export function logout(bean,vthis,socket){
	vthis.$router.push('/login/login')
}

// 创建群回调
export function create_cluster(bean,vthis,socket){
	// 保存群到本地
	saveCluster(bean,c_res=>{
		if(!c_res){
			return
		}
		// 保存群成员
		let mId = bean.owner.id
		let clusterId = bean.owner.clusterId
		let friendsOpenId = bean.owner.friendsOpenId
		webGetClusterMember(clusterId,data=>{
			if(data === false || data.length === 0){
				return
			}
			saveClusterMembers(data,cm_res=>{
				if(!cm_res){
					return
				}
				// 查询客服信息
				getCustomByWxid(bean.with_account_open_id,c_data=>{
					if(c_data.id === undefined){
						return
					}
					let saveData = {
						fans_id:bean.cluster_id,
						custom_wx_id: c_data.open_id,
						custom_wx_name:c_data.wx_name,
						custom_wx_photo:c_data.wx_photo,
						fans_wx_id:bean.wechat_cluster_id,
						fans_wx_name:bean.cluster_name,
						fans_wx_photo: bean.cluster_photo,
						is_send: 1
					}
					let content = c_data.wx_name + '创建了新群，群名为：'+bean.cluster_name
					webSaveClusterRecord(saveData,content,'system',{is_send: 1},r_res=>{
						if(r_res){
							let new_data = {
								  content: content,
								  friendId: bean.cluster_id,
								  clusterName: bean.cluster_name,
								  clusterImg: bean.cluster_photo,
								  fromId: bean.wechat_cluster_id,
								  mOpenId: c_data.open_id,
								  mPhoto:c_data.wx_photo,
								  mWxName: c_data.wx_name,
								  msgType: 2,
								  recentlyId: r_res.recently_id,
								  recodeId: r_res.record_id,
								  time: (new Date()).getTime(),
								  toId: c_data.open_id,
								  type: 'system',
								  is_me:0,
								  is_send: 1
							}
							// 渲染消息
							handleMsg(new_data,vthis)
							vthis.$store.commit('updateOtherEvent',bean)
						}
					})
				})	
			})
		})
	})
}

// 通粉后的回调
export function update_fans(bean,vthis,socket){
	// 保存粉丝数据
	saveFriend(bean,fans_res=>{
		if(!fans_res){
			return
		}
		// 保存第一条聊天信息
		let new_data = {
			  content: bean.content,
			  friendId: bean.friend_id,
			  fromId: bean.account_open_id,
			  recentlyId: bean.recently_id,
			  recodeId: bean.recode_id,
			  time:new Date().getTime(),
			  toId: bean.friend_open_id,
			  type: '_Text',
			  is_me: 1,
			  is_send: 1,
			  msgType: 1
		}
		// 渲染消息
		handleMsg(new_data,vthis)
	})
}

// 群操作-删除并退出后的回调
export function C_ExitChatRoom(bean,vthis,socket){
	if(bean.clusterId === undefined){
		return
	}
	let clusterId = bean.clusterId
	// 删除本地群信息
	deleteCluster(clusterId,res=>{
		// 什么都不做
	})
	// 删除本地群成员信息
	deleteClusterMemberByClusterId(clusterId,res=>{
		// 什么都不做
	})
	// 删除最近聊天表信息
	deleteRecentlyByFIdAndType(clusterId,2,res=>{
		// 什么都不做
	})
	vthis.$store.commit('updateOtherEvent',bean)
}

// 修改备注后的回调
export function reConRemark(bean,vthis,socket){
	if(bean.friend_id === undefined || bean.con_remark === undefined){
		return
	}
	// 修改粉丝表
	let fansData = {
		id: bean.friend_id,
		con_remark: bean.con_remark
	}
	updateFriend(fansData,res=>{
		// 什么都不做
	})
	
	// 修改最近联系人
	let rData = {
		friend_name: bean.con_remark
	}
	updateRecentlyByFIdAndType(bean.friend_id,1,rData,res=>{
		// 什么都不做
	})
	
	vthis.$store.commit('updateOtherEvent',bean)
}

// 标签同步处理
export function TagsSync(bean,vthis,socket){
	if(bean.tagList === undefined || bean.tagList.length == 0){
		return
	}
	deleteFansTagsByFansId(bean.tagList[0].friend_id,res=>{
		insertFansTags(bean.tagList,i_res=>{
			vthis.$store.commit('updateOtherEvent',bean)
		})
	})
}

// 朋友圈评论，点赞回调
export function replyMoment(bean,vthis,socket){
	if(bean.reply === undefined || bean.fromType === undefined){
		return
	}
	// 来自粉丝的评论或点赞
	if(bean.fromType === 'fans'){
		// 如果评论的是客服的朋友圈，则需要更新粉丝表数据
		if(bean.friendId !== undefined && bean.friendId != 0){
			let data = {
				id: bean.friendId
			}
			if(bean.isComment !== undefined && bean.isComment === true){
				data.is_comment = 1
			}
			if(bean.isZan !== undefined && bean.isZan === true){
				data.is_zan = 1
			}
			updateFriend(data,res=>{
				// nothing to do
			})
		}
		// 获取粉丝的信息，并整理评论信息
		if(bean.customId !== undefined && bean.friends_open_id !== undefined){
			getFansByCustomIdAndWxid(bean.customId,bean.friends_open_id,res=>{
				if(res.id !== undefined){
					// 保存最新的评论
					let mReply = JSON.parse(JSON.stringify(bean))
					mReply.fans = {
						id: res.id,
						wx_name: res.wx_name,
						wx_photo: res.wx_photo
					}
					// 回复的原始内容
					let reply = bean.reply
					if(reply.accountSnsId === undefined || reply.content === undefined){
						return
					}
					// 点赞
					let fabulous = {}
					let comment = {}
					if(reply.content === ''){
						fabulous = {
							dzName:reply.friendName,
							dzWxid:reply.friendOpenId
						}
					}
					// 评论
					else{
						comment = {
							commentId: reply.accountCommentId,
							commentText:reply.content,
							commentToUser: '',
							commentToWxid:'',
							commentUser: reply.friendName,
							commentUserWxid:reply.friendOpenId,
							showOpt: false
						}
						// 判断有没有@谁
						if(reply.arguedName !== undefined && reply.arguedOpenId !== undefined){
							comment.commentToUser = reply.arguedName
							comment.commentToWxid = reply.arguedOpenId
						}
					}
					mReply.fabulous = fabulous
					mReply.comment = comment
					mReply.SnsId = bean.reply.accountSnsId
					vthis.$store.commit('updateMReply',{
						type: 'add',
						data: mReply
					})
				}	
			})
		}	
	}
}

// 处理确认收取红包后的回调
export function redPackage(bean,vthis,socket){
	changeRTStatus(bean,'redPackage',vthis)
}

// 处理确认收取转账后的回调
export function transferAccounts(bean,vthis,socket){
	changeRTStatus(bean,'transferAccounts',vthis)
}

// 消息撤回回调
export function messageWithdraw_d(bean,vthis,socket){
	if(bean.recodeId === undefined){
		return
	}
	let data = {
		content :bean.content,
		type : 'system'
	}
	// 删除服务器端聊天记录-普通消息
	if(bean.chatType == 1){
		// 更新本地聊天记录
		updateChatRecordById(bean.recodeId,data,d_res=>{
			vthis.$store.commit('updateOtherEvent',bean)
		})
	}else{
		// 更新本地聊天记录
		updateClusterRecordById(bean.recodeId,data,d_res=>{
			vthis.$store.commit('updateOtherEvent',bean)
		})
	}
}

// 同步客服群回调
export function C_SyncCluster_R(bean,vthis,socket){
	if(bean.openId === undefined){
		return
	}
	getCustomByWxid(bean.openId,res=>{
		webGetSyncCluster(bean.openId,res.async_cluster_id,clusters=>{
			if(clusters.length === 0){
				return
			}
			 DbConfig.connect().transaction(tx=>{
				for(let i in clusters){
					// 添加群数据
					tx.executeSql('insert into yswl_cluster(id,cluster_name,cluster_photo,wechat_cluster_id,owner_id)'+
						'values(?,?,?,?,?)',
						[clusters[i].id,clusters[i].cluster_name,clusters[i].cluster_photo,clusters[i].wechat_cluster_id,clusters[i].owner_id],
						(tx,results)=>{
							// console.log(results)
						},
						(tx,error)=>{
							// console.log(error)
					})
					// 添加成员数据-从服务器查询，如果没数数据，则只录入客服自己的
					webGetClusterMember(clusters[i].id,menbers=>{
						if(menbers !== false && menbers.length > 0){
							let sql = 'insert into yswl_cluster_member(id,cluster_id,open_id) values'
							for (let j = 0; j < menbers.length; j++) {
								sql += '('+menbers[j].id+','+menbers[j].cluster_id+',"'+menbers[j].friends_open_id+'")'
								if(j < menbers.length - 1){
									sql += ','
								}
							}
							DbConfig.connect().transaction(tx=>{
								tx.executeSql(sql,[],(tx,results)=>{ 
									// console.log(results)
								},(tx,error)=>{
									// console.log(error)
								})
							}) 
						}else{
							tx.executeSql('insert into yswl_cluster_member(id,cluster_id,open_id)'+
								'values(?,?,?)',
								[clusters[i].m_id,clusters[i].id,clusters[i].open_id],
								(tx,results)=>{
									// console.log(results)
								},
								(tx,error)=>{
									// console.log(error)
								})
						}
					})
					// 更新客服信息
					if(i == clusters.length - 1){
						tx.executeSql('update yswl_custom set async_cluster_id = '+ clusters[i].id +' WHERE open_id = "'+clusters[i].open_id+'"')
					}
				}
			})
		})
	})
}

// 隐藏粉处理
export function FriendHide(bean,vthis,socket){
	if(bean.a_id === undefined || bean.a_wxid === undefined || bean.f_wxid === undefined){
		return
	}
	getFansByCustomIdAndWxid(bean.a_id,bean.f_wxid,fans=>{
		if(fans.id === undefined){
			return
		}
		// 删除本地粉丝
		deleteFriendById(fans.id,d_res=>{
			// nothing to do
		})
		// 删除最近聊天表
		deleteRecentlyByFIdAndType(fans.id,1,dr_res=>{
			// nothing to do
		})
		// 提交到全局状态
		bean.f_id = fans.id
		vthis.$store.commit('updateOtherEvent',bean)
	})
}